module.exports = __webpack_public_path__ + "static/shauna-7ed6a835ee6eedc55f9ce847ea9f9af7.png";